var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowCircleLeftGradient = function SvgArrowCircleLeftGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.684,
    cy: 25.681,
    r: 18.16,
    fill: "url(#arrow-circle-left-gradient_svg__a)",
    transform: "rotate(-135 25.684 25.681)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#704414",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m24.816 20.363 5 5-5 5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "arrow-circle-left-gradient_svg__a",
    x1: 10.328,
    x2: 37.992,
    y1: 29.128,
    y2: 28.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#DDC026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17B18"
  })))));
};
export default SvgArrowCircleLeftGradient;